module.exports = __webpack_public_path__ + "assets/a844f0884d08cf1fc872bfc2cfeae02c.mp4";